import { EmailMatchingRecordType } from './types';

export const isMatchedEdited = (record: EmailMatchingRecordType) => {
  const isCommunityDifferent = record.ai_matched_community !== record.matched_community;
  const isSenderTypeDifferent = record.ai_sender_type !== record.sender_type;
  const isDeliveryMethodDifferent = record.ai_delivery_method !== record.delivery_method;

  const aiCommunicationTypes = [...(record.ai_communication_types ?? [])].sort((a, b) => a - b);
  const communicationTypes = [...(record.communication_types ?? [])].sort((a, b) => a - b);
  const isCommunicationTypesDifferent = aiCommunicationTypes.join(',') !== communicationTypes.join(',');

  return isCommunityDifferent || isSenderTypeDifferent || isDeliveryMethodDifferent || isCommunicationTypesDifferent;
};
